import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import React, { useState } from 'react';

// Import Pages
import Home from './Pages/Home';

// Import Components
import Navbar from './Components/Navbar';
import AnimatedBackground from './Components/Background/AnimatedBackground';
import ContactModal from './Components/ContactForm/ContactModal';
import CalendlyModal from './Components/ContactForm/CalendlyModal';

const App = () => {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);

  const openInquiryModal = () => setIsInquiryModalOpen(true);
  const closeInquiryModal = () => setIsInquiryModalOpen(false);

  const openCalendlyModal = () => setIsCalendlyModalOpen(true);
  const closeCalendlyModal = () => setIsCalendlyModalOpen(false);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <AnimatedBackground />
          <Helmet>
            {/* Default meta tags for the entire app */}
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#000000" />
            <link rel="canonical" href="https://bytesand.ai" />
            
            {/* Default title and description */}
            <title>ByteSand | AI Business Automation Solutions</title>
            <meta 
              name="description" 
              content="Transform your business operations with AI voice agents and automation solutions. Reduce costs, improve efficiency, and deliver better customer experiences."
            />

            {/* Open Graph meta tags for social sharing */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content="ByteSand | AI Business Automation Solutions" />
            <meta property="og:description" content="Transform your business operations with AI voice agents and automation solutions." />
            <meta property="og:url" content="https://bytesand.ai" />
            
            {/* Twitter Card meta tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="ByteSand | AI Business Automation Solutions" />
            <meta name="twitter:description" content="Transform your business operations with AI voice agents and automation solutions." />
          </Helmet>

          <Navbar openCalendlyModal={openCalendlyModal} />
          <Home openModal={openInquiryModal} />
          <ContactModal isOpen={isInquiryModalOpen} onClose={closeInquiryModal} />
          <CalendlyModal isOpen={isCalendlyModalOpen} onClose={closeCalendlyModal} />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;